import CryptoJS from 'crypto-js';

const SECRET_KEY = CryptoJS.enc.Utf8.parse('12345678901234567890123456789012'); // 32-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte IV

// Convert Base64 to URL-Safe Base64
const base64ToUrlSafe = (str) =>
  str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

// Encrypt function
export const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return base64ToUrlSafe(encrypted); // Make it URL-safe
};
